import React, { useState } from 'react';
import { Button } from 'antd';
import AddEcardForm from '../Components/AddEcardForm';
import ViewEcards from '../Components/ViewEcards';

const UploadEcard: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'add' | 'view'>('add');

  return (
    <div style={{ maxWidth: '1600px', margin: '0 auto', padding: '0 20px' }}>
      <div style={{ marginBottom: '15px', display: 'flex', gap: '10px' }}>
        <Button
          type={activeTab === 'add' ? 'primary' : 'default'}
          onClick={() => setActiveTab('add')}
          style={{ 
            backgroundColor: activeTab === 'add' ? '#1890ff' : 'transparent',
            color: activeTab === 'add' ? 'white' : '#1890ff',
            borderColor: '#1890ff'
          }}
        >
          Add Ecards
        </Button>
        <Button
          type={activeTab === 'view' ? 'primary' : 'default'}
          onClick={() => setActiveTab('view')}
          style={{ 
            backgroundColor: activeTab === 'view' ? '#1890ff' : 'transparent',
            color: activeTab === 'view' ? 'white' : '#1890ff',
            borderColor: '#1890ff'
          }}
        >
          View Ecards
        </Button>
      </div>
      <h1 style={{ marginBottom: '15px' }}>Celebration Ecards</h1>
      
      
      {activeTab === 'add' ? (
        <AddEcardForm />
      ) : (
        <ViewEcards />
      )}
    </div>
  );
};

export default UploadEcard;